module.exports = __webpack_public_path__ + "img/mobile-iphone13.f336ef15.png";